import {
  READ_PURCHASE_CREDIT_NOTE,
  READ_PURCHASE_INVOICE,
  READ_SALE_CREDIT_NOTE,
  READ_SALE_INVOICE,
} from '../../../constants/eInvoicePermissions';
import { formatAccessDeniedMessage } from '../../../utils/accessDeniedMessage';

const SCOPE_PERMISSIONS = [
  { permission: READ_SALE_INVOICE, labelKey: 'scope_sales_invoices' },
  { permission: READ_SALE_CREDIT_NOTE, labelKey: 'scope_sales_credit_notes' },
  { permission: READ_PURCHASE_INVOICE, labelKey: 'scope_purchase_invoices' },
  { permission: READ_PURCHASE_CREDIT_NOTE, labelKey: 'scope_purchase_credit_notes' },
];

export function getDocumentReportGenerateAccess({ hasEInvoicePermission, adminEmail }) {
  const allowedTypes = SCOPE_PERMISSIONS.filter(({ permission }) => hasEInvoicePermission(permission)).map(
    ({ labelKey }) =>labelKey,
  );

  const hasSalesPurchaseScope = allowedTypes.length > 0;

  if (!hasSalesPurchaseScope) {
    const template =
      'You do not have permission to access sales or purchase documents. Please contact your organization admin ({email}) to update your permissions.';
    return {
      hasSalesPurchaseScope: false,
      tooltipMessage: formatAccessDeniedMessage(template, adminEmail),
    };
  }

  const scopeTemplate =
    'This report will only include documents you have access to: {documentTypes}.';
  const tooltipMessage = scopeTemplate.replace('{documentTypes}', allowedTypes.join(', '));

  return {
    hasSalesPurchaseScope: true,
    tooltipMessage,
  };
}
